import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ObligationsEditPage } from './ObligationsEditPage';

// This wrapper component uses React Router v6 hooks and passes them as props
// to the component in a format compatible with React Router v5
export function ObligationsEditPageWrapper(props) {
  const params = useParams();
  const navigate = useNavigate();
  
  // Create a history object that mimics the React Router v5 history
  const history = {
    push: (path) => navigate(path),
    location: window.location,
  };
  
  // Create a match object that mimics the React Router v5 match
  const match = {
    params,
    url: window.location.pathname,
  };
  
  return <ObligationsEditPage {...props} match={match} history={history} />;
}
